class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.summary.nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  open() {
    if (this.mainDetailsToggle.open) return;
    this.mainDetailsToggle.setAttribute('open', true);
    this.summary.setAttribute('aria-expanded', true);
    if (!this.animations) this.animations = this.content.getAnimations();
    this.animations.forEach((animation) => animation.play());
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', false);
    if (!this.animations) this.animations = this.content.getAnimations();
    this.animations.forEach((animation) => animation.cancel());
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.mouseOverDelay = 230;
    this.mq = window.matchMedia('screen and (pointer: coarse)');

    this.addEventListener('mouseover', this.handleHover.bind(this));
    this.addEventListener('mouseout', this.handleHover.bind(this));
    this.summary.addEventListener('click', this.onClick.bind(this));
  }

  get trigger() {
    return this.mq.matches ? 'click' : this.getAttribute('data-toggle-trigger');
  }

  onClick() {
    if (this.trigger === 'hover' && this.mainDetailsToggle.open && this.summary.hasAttribute('data-follows-link')) {
      return (window.location.href = this.summary.getAttribute('data-follows-link'));
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  handleHover(event) {
    if (this.trigger === 'click') return;
    if (event.type === 'mouseover') {
      clearTimeout(this.hoverTimeout);
      this.open();
    } else if (event.type === 'mouseout') {
      this.hoverTimeout = setTimeout(() => this.close(), this.mouseOverDelay);
    }
  }
}

customElements.define('header-menu', HeaderMenu);

class MegaMenu extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.handleItemEvent.bind(this));
    this.addEventListener('mouseover', this.handleItemEvent.bind(this));
  }

  handleItemEvent(event) {
    if (
      !['SUMMARY', 'A'].some(
        (tagName) => event.target.tagName === tagName || event.target.closest(tagName)?.tagName === tagName
      )
    ) {
      return;
    }
    let li = event.target.closest('li');
    let linkLevel = li.getAttribute('data-link-level');
    let linkHandle = li.getAttribute('data-link-handle');

    publish(PUB_SUB_EVENTS.megaMenuItemChange, {
      link: li,
      linkLevel,
      linkHandle,
    });
  }
}

customElements.define('mega-menu', MegaMenu);

class MegaMenuPromotions extends HTMLElement {
  constructor() {
    super();

    this.allPromotions = this.querySelectorAll('.promotion');
    this.previousHandle = '';
    this.previousLevel = 0;
  }

  itemChangeUnsubscriber = undefined;

  connectedCallback() {
    this.itemChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.megaMenuItemChange, (event) => {
      this.onItemChange(event);
    });
  }

  disconnectedCallback() {
    if (this.itemChangeUnsubscriber) {
      this.itemChangeUnsubscriber();
    }
  }

  setPromotions(level, handle) {
    let promotions = this.querySelectorAll(`[data-link-level="${level}"][data-link-handle="${handle}"]`);

    if (promotions.length) {
      this.previousLevel = level;
      this.allPromotions.forEach((p) => p.classList.add('hidden'));
      promotions.forEach((p) => p.classList.remove('hidden'));
    }

    return promotions.length ? promotions : null;
  }

  onItemChange(event) {
    let currentLevel = Number(event.linkLevel);
    let promotions = this.setPromotions(currentLevel, event.linkHandle);

    if (!promotions && currentLevel <= this.previousLevel) {
      let parentLink = event.link.parentElement.closest('li');

      if (!parentLink) {
        this.allPromotions.forEach((p) => p.classList.add('hidden'));
        return;
      }

      let parentLinkLevel = Number(parentLink.getAttribute('data-link-level'));
      let parentLinkHandle = parentLink.getAttribute('data-link-handle');

      this.setPromotions(parentLinkLevel, parentLinkHandle);
    }
  }
}

customElements.define('mega-menu-promotions', MegaMenuPromotions);
